/**
 * Restores data that was persisted in the local storage
 *
 * @param {string} itemName The key of the data to restore
 * @param {string} storeName The key of the store where the data was persisted
 * @param {string} defaultValue The default value to use if the data is not found in the local storage
 */
export function restoreFromLocalStorage(itemName: string, storeName: string, defaultValue: any): any {
  const state = JSON.parse(window.localStorage.getItem(storeName) || "{}").state;
  if (!state) {
    return defaultValue;
  }

  return state[itemName] || defaultValue;
}
